import styled from 'styled-components';

import { Text } from '@/nova/components';
import { CUST, CUST_ANIM } from '../../../../theme/customizer-tokens';

/** Outer plate (surface-secondary) wrapping the header + body. */
export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 4px;
  border-radius: 20px;
  background: ${CUST.dnsTableWrapBg};
`;

/* Shared 4-column grid (Type · Name · Data · TTL). */
const GRID = 'grid-template-columns: 100px 176px minmax(0, 1fr) 120px;';

export const HeaderRow = styled.div`
  display: grid;
  ${GRID}
  gap: 16px;
  align-items: center;
  padding: 10px 16px;
`;

export const HeaderCol = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
`;

export const HeaderCell = styled(Text)<{ $strong?: boolean }>`
  font-size: 12px;
  font-weight: 500;
  line-height: 1.34;
  color: ${({ $strong }) => ($strong ? CUST.dnsHeaderStrong : CUST.dnsHeaderMuted)};
`;

export const InfoGlyph = styled.span`
  display: inline-flex;
  color: ${CUST.dnsHeaderMuted};
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 16px;
  background: ${CUST.dnsTableBodyBg};
`;

export const RowGrid = styled.div`
  position: relative;
  display: grid;
  ${GRID}
  gap: 16px;
  align-items: center;
  min-height: 52px;
  padding: 12px 16px;

  &:not(:last-child)::after {
    content: '';
    position: absolute;
    inset: auto 0 0 0;
    height: 1px;
    background: ${CUST.dnsRowSeparator};
    opacity: 0.5;
  }
`;

export const Cell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

export const TypeText = styled(Text)`
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;
  color: ${CUST.dnsCellStrong};
  white-space: nowrap;
`;

export const CellText = styled(Text)`
  min-width: 0;
  font-size: 14px;
  line-height: 1.43;
  color: ${CUST.dnsCellStrong};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CopyBtn = styled.button`
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  width: 22px;
  height: 22px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: ${CUST.dnsCopyIcon};
  cursor: pointer;
  transition: color ${CUST_ANIM.INTERACT_MS}ms ease;

  &:hover {
    color: ${CUST.white};
  }
`;